import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import useActiveLenders from 'components/hooks/useActiveLenders'

import styles from './styles.module.scss'

const setPartnerCls = (partner, allLenders) => {
  const lender = allLenders.find((l) => l.slug === partner)

  return lender ? styles[partner] : styles.default
}

const PartnerLogo = ({ type = 'normal', partner, className }) => {
  const allPersonalLoanLenders = useActiveLenders('personal')
  const allStudentLoanRefiLenders = useActiveLenders('refi')
  const allStudentLoanLenders = useActiveLenders('in_school')

  const allLenders = [
    ...allStudentLoanLenders,
    ...allPersonalLoanLenders,
    ...allStudentLoanRefiLenders,
  ]

  const cls = cx(styles['lender-logo'], setPartnerCls(partner, allLenders), styles[type], className)

  return <div data-testid={`partner-logo-${partner}`} className={cls} />
}

PartnerLogo.propTypes = {
  partner: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['normal', 'icon']),
  className: PropTypes.string,
}

export { PartnerLogo, setPartnerCls }
